<template>
  <quick-quote-page
    id="Archived Plans"
    :optionsname="$options.name"
  >
    <template #keyselection>
      <select-customer
        v-if="customers.data.length > 1"
        id="2-maintain"
        v-model="customers.selectedItem"
        :appendhint="`to view its Archived ${displayAsPlural}`"
        @change="customer_onChange"
      />
    </template>

    <template #content>
      <plans-archived-table
        ref="maintenancePlansArchivedTable"
      />
    </template>
  </quick-quote-page>
</template>

<script>
  import { get } from 'vuex-pathify'
  import QuickQuotePage from '@/components/QuickQuotePage'
  import PlansArchivedTable from '@/components/maintenance/tables/PlansArchivedTable'

  export default {
    name: 'PlansArchivedView',

    components: {
      QuickQuotePage,
      PlansArchivedTable,
    },

    data () {
      return {}
    },

    computed: {
      users: get('user/users'),
      customers: get('customer/customers'),
      displayAsPlural: get('plan/displayAsPlural'),
    },

    methods: {
      customer_onChange () {
        this.$refs.maintenancePlansArchivedTable.retrieveAllPlans()
      },
    },
  }
</script>

<style scoped>

</style>
